import React from "react";
import propTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ component, path }) => {
  const isLoggedIn = useSelector((state) => state.auth.login);
  const pathname = window.location.pathname;
  return isLoggedIn ||
    pathname.includes("/verify-email") ||
    pathname.includes("/paypal/payment") ||
    pathname.includes("/setpassword") ||
    pathname.includes("/reset-password") ? (
    <Route component={component} path={path} />
  ) : (
    <Redirect to="/" />
  );
};

export default ProtectedRoute;
